import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'

import { UserRoutes } from '../modules/users/UserRoutes'
import { Profile } from '../modules/profile/Profile'
import { SystemSettingsRoutes } from '../modules/systemSettings/SystemSettingsRoutes'
import { useAuth } from '../modules/auth'
import { OperationRankingRoutes } from '../modules/operationRanking/OperationRankingRoutes'
import { DeviceReportRoutes } from '../modules/deviceReport/DeviceReportRoutes'
import { DiagnostiRoutes } from '../modules/diagnostic/DiagnosticRoutes'

const PrivateRoutes = () => {
  //const Profile = lazy(() => import('../modules/profile/Profile'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  const ROLE_ADMIN = parseInt(process.env.REACT_APP_ROLE_ADMIN+"");
  const ROLE_MANAGER = parseInt(process.env.REACT_APP_ROLE_MANAGER+"");
  const ROLE_EMPLOYEE = parseInt(process.env.REACT_APP_ROLE_EMPLOYEE+"");
  
  const {checkAuthorization} = useAuth();
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />

        <Route path='profile' element={<Profile />} />
        {/* Lazy Modules */}
      
        
        {checkAuthorization([ROLE_MANAGER, ROLE_EMPLOYEE]) &&  <Route
          path='system-settings/*'
          element={
            <SuspensedView>
              <SystemSettingsRoutes />
            </SuspensedView>
          }
        />}
        {checkAuthorization([ROLE_MANAGER, ROLE_EMPLOYEE]) &&  <Route
          path='operation-ranking/*'
          element={
            <SuspensedView>
              <OperationRankingRoutes />
            </SuspensedView>
          }
        />}
         {checkAuthorization([ROLE_MANAGER, ROLE_EMPLOYEE]) &&  <Route
          path='reports/*'
          element={
            <SuspensedView>
              <DeviceReportRoutes />
            </SuspensedView>
          }
        />}
         {checkAuthorization([ROLE_MANAGER, ROLE_EMPLOYEE]) &&  <Route
          path='diagnostic/*'
          element={
            <SuspensedView>
              <DiagnostiRoutes />
            </SuspensedView>
          }
        />}
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes, SuspensedView}
